import React from 'react'
import { HospitalCenterReqDto } from '../../../api/interfaces/LeadsDto'
import { getSHiftDisplayName } from '../../../utility/RolesUtility'
interface infoData {
    submittedData:any
  }
const CenterAndLocation:React.FC<infoData>=({submittedData})=> {
  return (
   <>
    {submittedData?.hospitalCenterReqDtos && submittedData?.hospitalCenterReqDtos?.length >0 &&
        (
        <div className=" p-10 bg-white">
          <p className=" font-bold text-2xl text-primary-color border-b pb-4 ">
            Centers and Locations
          </p>
          <div className="grid grid-cols-2 gap-8 mt-6">
          {submittedData?.hospitalCenterReqDtos?.map((item:HospitalCenterReqDto, index:number) => (
            <div className="border border-gray-200 rounded-lg py-4 pl-4 w-full">
           {item?.name &&
              <p className="font-bold text-[20px] text-gray-900">{item?.name || 'NA'}</p>}
              <div className="grid grid-cols-2 gap-5">
               {
                item?.specialization &&
                <div>
                <p className="font-normal text-sm text-gray-600 pt-2">
                  Specialization
                </p>
                <p className="font-semibold text-base text-gray-600 pt-2 ">
                 {item?.specialization || 'NA'}
                </p>
                </div>}
                {
                  item?.centerSize &&
                <div>
                <p className="font-normal text-sm text-gray-600 pt-2">
                  Center size
                </p>
                <p className="font-semibold text-base text-gray-600 pt-2">
                 {getSHiftDisplayName(item?.centerSize) || 'NA'}
                </p>
                </div>}
              </div>
              {
                item?.branchAddress &&
              <div className="flex pt-5 items-center gap-2">
                <img src="/images/location1_icon.svg" className="" />
                <p className="font-semibold text-sm text-gray-800 mb-0">{item?.branchAddress || 'NA'}</p>
              </div>}
            </div>))}
           
          </div>
        </div>)}</>
  )
}

export default CenterAndLocation
